import { IQueryContext } from 'src/app/services/query-context/models/IQueryContext';
import {
    EChartsHelper,
    MetricsGetterOptions,
} from '../../utils/echarts/echarts-helper';

/**
 * @deprecated This function is deprecated and will be removed in future versions.
 * Use {@link EChartsHelper.createRevenueMetricsGetter} instead.
 *
 * @param options - The options for the revenue metrics getter.
 * @returns This function returns the revenue metrics getter. Used in revenue-related charts when you need to show revenue metrics.
 */
export function getRevenueMetricsGetter(options: MetricsGetterOptions) {
    return EChartsHelper.createRevenueMetricsGetter(options);
}
